import React from "react";
import { CiEdit } from "react-icons/ci";
const ProviderAvailability = ({
  availability,
  setProviderAvailabilityModalOpen,
  setProviderAvailabilityData,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {availability &&
          availability?.map((item, index) => (
            <div key={index} className="flex border justify-between rounded-xl">
              <div className="rounded-l-xl">
                <p className="px-2 py-1">{item.date}</p>
                <div className="flex px-2 py-1">
                  {item?.time_slots?.length === 0 ? (
                    <p className="text-center text-gray-500">
                      No Slots Available
                    </p>
                  ) : (
                    item?.time_slots?.map((slot, slotIndex) => (
                      <p key={slotIndex} className={``}>
                        {slot?.time},{" "}
                      </p>
                    ))
                  )}
                </div>
              </div>
              <button
                className="border-l p-2"
                onClick={() => {
                  setProviderAvailabilityData(item);
                  setProviderAvailabilityModalOpen(true);
                }}
              >
                <CiEdit className="w-5 h-5 text-[#496ECC]" />
              </button>
            </div>
          ))}
      </div>
    </>
  );
};

export default ProviderAvailability;
